import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import './form';

document.addEventListener('DOMContentLoaded', () => {
  const datepickers = document.querySelectorAll('.form__input--datepicker');
  datepickers.forEach((datepicker) => {
    // eslint-disable-next-line no-new
    new AirDatepicker(datepicker, {
      locale: localeEn,
      autoClose: true,
    });
  });
});
